import { withAuthenticationRequired } from "@auth0/auth0-react"
import { Route, Routes, useLocation } from "react-router-dom"
import Egresados from "../components/Egresados/Egresados"
import NavBar from "../components/NavBar/NavBar"
import Page404 from "../components/Page404/Page404"
import Admin from "../screens/Admin"
import Empleado from "../screens/Empleado"
import UserRouter from "./UserRouter"

const redirecting = () => <div>Cargando...</div>

const AdminRoute = withAuthenticationRequired(Admin, { onRedirecting: redirecting })
const EmpleadoRoute = withAuthenticationRequired(Empleado, { onRedirecting: redirecting })
const EgresadosRoute = withAuthenticationRequired(Egresados, { onRedirecting: redirecting })

const IndexRouter = () => {
  const location = useLocation()

  return (
    <>
      {location.pathname.toLocaleLowerCase() !== "/promociones2026" &&
        location.pathname.toLocaleLowerCase() !== "/recomendaciones" && (
          <NavBar />
        )}
      <Routes>
        <Route path="/*" element={<UserRouter />} />
        <Route path="/admin/*" element={<AdminRoute />} />
        <Route path="/empleado" element={<EmpleadoRoute />} />
        <Route path="/egresados/:id" element={<EgresadosRoute />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </>
  )
}

export default IndexRouter
